export default function() {
	return {
		loading: false,
		items: [],
		modalUrl: undefined
	};
}
